import {createAction} from '@reduxjs/toolkit'

export const selectLastPaymentMethod = createAction('paymentMethod/selectLastPaymentMethod')

/** 충전결제 해제 action */
export const unselectRechargePayMethod = createAction('paymentMethod/unselectRechargePayMethod')
